module.exports = __webpack_public_path__ + "img/pl.7e588cc1.svg";